<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="ref_id">
                                            {{ $t('label.reference_id') }}
                                        </kt-form-label>
                                        <kt-form-control ref="ref_id" dir="ltr" name="ref_id" id="ref_id" v-model="query.ref_id" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="tracking_code">
                                            {{ $t('label.tracking_code') }}
                                        </kt-form-label>
                                        <kt-form-control ref="tracking_code" dir="ltr" name="tracking_code" id="tracking_code" v-model="query.tracking_code" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="price">
                                            {{ $t('transactions-report.price') }}
                                        </kt-form-label>
                                        <kt-form-control ref="price" name="price" id="price" v-model="query.price"></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="card_number">
                                            {{ $t('label.card_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="card_number"
                                                name="card_number"
                                                id="card_number"
                                                style="direction:ltr"
                                                v-bind:placeholder="$t('label.card_number_sample')"
                                                v-model="query.card_number"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group ref="statusSelectGroup">
                                        <kt-form-label for="status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="5" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="from_date">
                                            {{ $t('label.from_date') }}
                                        </kt-form-label>
                                        <button id="reset_from_date"
                                                @click="clearFromDate"
                                                class=" btn btn-label-danger trash-btn"
                                        >
                                            <i class="la la-trash-o"></i>
                                        </button>
                                        <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                input-class="form-control"
                                                id="from_date"
                                                name= "from_date"
                                                v-model="query.from_date"
                                                type="datetime" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="to_date">
                                            {{ $t('label.to_date') }}
                                        </kt-form-label>
                                        <button id="reset_to_date"
                                                @click="clearToDate"
                                                class=" btn btn-label-danger trash-btn"
                                        >
                                            <i class="la la-trash-o"></i>
                                        </button>
                                        <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                input-class="form-control"
                                                id="to_date"
                                                name= "to_date"
                                                v-model="query.to_date"
                                                type="datetime"
                                        />
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                            <kt-form-row>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <kt-row>
                                <kt-col xs="12" sm="6" md="6">
                                    <button class="btn btn-success btn-wide" @click="action($event, query)">{{ $t('label.filter') }}</button>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6">
                                    <button
                                            class="btn btn-success btn-wide float-right"
                                            size="md"
                                            type="button"
                                            id="export_app_transations_btn"
                                            @click="exportExcel($event, query)"
                                    >
                                        {{ $t('btn.export_transaction_to_excel') }}
                                    </button>
                                </kt-col>
                            </kt-row>
                        </kt-form-section>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
    import { statusStr, transactionStatus } from '@/constants/transactionStatus'
    import Inputmask from 'inputmask'
    import axios from "axios";
    import { ApiUrl } from '@/common/api.service'

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            exportExcel: {
                default: function(e, query) {},
                required: true,
            }
        },
        data() {
            return {
                statuses: [
                    {
                        name: null,
                        value: null
                    },
                    {
                        name: statusStr.INIT,
                        value: transactionStatus.INIT
                    },
                    {
                        name: statusStr.FAILED,
                        value: transactionStatus.FAILED
                    },
                    {
                        name: statusStr.SUCCEED,
                        value: transactionStatus.SUCCEED
                    },
                    {
                        name: statusStr.CANCELED,
                        value: transactionStatus.CANCELED
                    }
                ],
                query: {},
            }
        },
        mounted() {
            this.initial()
        },
        methods: {
            initial() {
                Inputmask('9999-99-99').mask(document.querySelectorAll('.maskable'))
            },
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
        }

    }
</script>

<style>
    #card_number:-moz-placeholder {
        text-align: right;
    }
    #card_number:-ms-input-placeholder {
        text-align: right;
    }
    #card_number::-webkit-input-placeholder {
        text-align: right;
    }
</style>